import React from 'react';
import withRouter from 'HOCs/withRouter';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from 'Components/ThematicIcon/ThematicIcon';
import css from './VerifiedAccounts.mobile.scss';
import { FormattedMessage as Translation } from 'react-intl';
import { DARK, LIGHT } from 'Constants/buttons';

const iconSize = 28;
const iconSizeIsClassified = 16;

export class VerifiedAccounts extends React.PureComponent {
    static propTypes = {
        user: PropTypes.object.isRequired,
        showTitle: PropTypes.bool,
        socialIconType: PropTypes.string,
        isClassified: PropTypes.bool,
        className: PropTypes.string
    };

    static defaultProps = {
        socialIconType: 'dark',
        isClassified: false
    };

    iconsDark = {
        facebook: 'facebookProfileValidated',
        phone: 'call',
        gplus: 'googleProfileValidated',
        email: 'mail'
    };

    iconsLight = {
        facebook: 'facebookVerifiedLight',
        phone: 'call',
        gplus: 'googleVerifiedLight',
        email: 'mail'
    };

    iconsProfile = {
        gplus: 'googleProfileNew',
        email: 'mail',
        phone: 'call'
    }

    getBadges = () => {
        const { badges = [] } = this.props.user;

        return badges.filter(badge => badge.status === true);
    }

    getBadgeIcon = (badge, socialIconType) => {
        if (socialIconType === LIGHT) {
            return this.iconsLight[badge.type];
        }
        else if (socialIconType === DARK) {
            return this.iconsDark[badge.type];
        }
        return this.iconsProfile[badge.type];
    }

    renderBadges = (badges, socialIconType, isClassified, className) => {
        return (
            badges.map((badge, index) => {
                const badgeIcon = this.getBadgeIcon(badge, socialIconType) || badge.name;

                return (
                    <div
                        className={ classNames(css.icon, className) }
                        key={ index }
                    >
                        <Icon
                            icon={ badgeIcon }
                            size={ isClassified ? iconSizeIsClassified : iconSize }
                        />
                    </div>
                );
            })
        );
    }

    render() {
        const badges = this.getBadges();
        const hasBadges = badges.length !== 0;
        const { showTitle, socialIconType, isClassified, className } = this.props;

        return (
            hasBadges && (
                <React.Fragment>
                    { showTitle
                        && <div className={ css.verifiedAccountTitle }>

                            <Translation id="verifiedAccountTitle" />

                        </div>
                    }
                    <div
                        className={ socialIconType === 'light' ? css.socialIconsLight : css.socialIconsDark }
                        data-aut-id="verifiedAccount"
                    >
                        { this.renderBadges(badges, socialIconType, isClassified, className)}
                    </div>
                </React.Fragment>
            )
        );
    }
}

export default withRouter(VerifiedAccounts);
